import { API_URL } from '../config'

const defaultHeaders = {
  accept: 'application/json',
  'content-type': 'application/json'
}

export function setTokenHeader(value) {
  defaultHeaders.Authorization = value
}

export function clearTokenHeader() {
  delete defaultHeaders.Authorization
}

export default function request(path, args = {}) {
  const url = `${API_URL}/${path}`

  const options = {
    headers: args.headers || defaultHeaders,
    method: args.method || 'GET'
  }

  if (args.data) {
    options.body = JSON.stringify(args.data)
    options.headers['content-type'] = 'application/json'
  }
  return fetch(url, options).then(res => {
    if (res.status === 204) {
      return res
    }
    if (res.status >= 200 && res.status < 300) {
      return res.json().then(body => [body, res])
    }
    if (res.status === 401 || res.status === 403) {
      // Optionally, trigger a token refresh or redirect to login
      throw new Error('Unauthorized')
    }
    const error = new Error(res.statusText)
    error.res = res
    error.status = res.status
    throw error
  })
}

export function requestFile(path, args = {}) {
  const url = `${API_URL}/${path}`

  const options = {
    headers: args.headers || defaultHeaders,
    method: args.method || 'GET'
  }

  if (args.data) {
    options.body = JSON.stringify(args.data)
    options.headers['content-type'] = 'application/json'
  }
  return fetch(url, options).then(res => {
    if (res.status >= 200 && res.status < 300) {
      return res
    }
    if (res.status === 413) {
      return 413
    }
    const error = new Error(res.statusText || `Request failed with status ${res.status}`)
    error.status = res.status
    error.res = res
    return Promise.reject(error)
  })
}

export function base64ToBlob(base64, mime = 'application/octet-stream') {
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i)
  }
  return new Blob([bytes], { type: mime })
}

export function downloadPdfFromPayload(payload, defaultFilename) {
  if (!payload?.pdf) {
    return Promise.reject(new Error('Missing PDF payload'))
  }
  const blob = base64ToBlob(payload.pdf, 'application/pdf')
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `${payload.filename || defaultFilename}.pdf`
  link.click()
  URL.revokeObjectURL(url)
  return Promise.resolve({ worked: 'worked' })
}

export function downloadPdfFromBase64Response(response, defaultFilename, parsedPayload = null) {
  const worked = response.headers.get('reult')
  if (worked !== 'worked') {
    return Promise.resolve({ worked })
  }

  const legacyFileUrl = response.headers.get('fileUrl')
  if (legacyFileUrl) {
    const link = document.createElement('a')
    link.href = legacyFileUrl
    link.download = `${defaultFilename}.pdf`
    link.click()
    return Promise.resolve({ worked: 'worked' })
  }

  const payloadPromise = parsedPayload ? Promise.resolve(parsedPayload) : response.json()

  return payloadPromise.then(payload => downloadPdfFromPayload(payload, defaultFilename))
}
